import { Check } from "lucide-react";
import { useApp } from "@/context/AppContext";

const KEYS = ["stepWelcome", "stepDetails", "stepSlot", "stepConfirm"];

export default function StepProgress() {
  const { state, t } = useApp();
  return (
    <ol className="mb-6 flex items-center gap-2" data-testid="step-progress">
      {KEYS.map((k, i) => {
        const n = i + 1;
        const done = state.step > n;
        const active = state.step === n;
        return (
          <li key={k} className="flex flex-1 items-center gap-2" data-testid={`step-indicator-${n}`}>
            <span
              className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs transition-colors duration-500 ${
                done ? "bg-emerald-400 text-emerald-950" : active ? "bg-amber-300 text-emerald-950" : "bg-white/10 text-emerald-100/60"
              }`}
            >
              {done ? <Check className="h-4 w-4" /> : n}
            </span>
            <span className={`hidden text-xs md:inline ${active ? "text-amber-200" : "text-emerald-100/60"}`}>{t(k)}</span>
            {n < 4 && <span className={`h-px flex-1 transition-colors duration-700 ${done ? "bg-emerald-400/70" : "bg-white/10"}`} />}
          </li>
        );
      })}
    </ol>
  );
}
